import { BaseService } from '../../infra/base.service'
import type { EventsRepository } from './events.repository'

export class EventsService extends BaseService<null> {
    constructor(private eventsRep: EventsRepository) {
        super(eventsRep)
    }

    async getEventTypes() {
        return await this.eventsRep.getEventTypes()
    }

    async getEventSources() {
        return await this.eventsRep.getEventSources()
    }
}
